import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { CancelHandler, InItHandleModal, OpenHandler } from './modal.classes';


export interface ModalStateModel {
  result: 'open' | 'close' | 'null'
}

@State<ModalStateModel>({
  name: 'modal',
  defaults: {
    result: 'null'
  },
})

@Injectable()
export class ModalState {
  @Action(InItHandleModal)
  InItHandleModal( ctx: StateContext<ModalStateModel>){
      ctx.patchState({result: 'null'});
  }

  @Action(OpenHandler)
  OpenHandler( ctx: StateContext<ModalStateModel>){
      ctx.patchState({result: 'open'});
  }

  @Action(CancelHandler)
  CancelHandler( ctx: StateContext<ModalStateModel>){
      ctx.patchState({result: 'close'});
  }
}


